import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { RefObject } from 'react';

interface SearchBoxProps {
  search: string;
  setSearch: (value: string) => void;
  onSearch: () => void;
  onClose: () => void;
  searchInputRef: RefObject<HTMLInputElement>;
  horizontalPadding: string;
}

export const SearchBox = ({
  search,
  setSearch,
  onSearch,
  onClose,
  searchInputRef,
  horizontalPadding,
}: SearchBoxProps) => {
  return (
    <div
      className="search-box-container pt-3 pb-2"
      style={{
        backgroundColor: 'transparent',
        paddingLeft: horizontalPadding,
        paddingRight: horizontalPadding,
        marginBottom: '16px',
      }}
    >
      <div className="flex justify-content-between w-full flex-row gap-2">
        <div
          className="flex flex-row gap-2"
          style={{ width: 'calc(100% - 50px)' }}
        >
          <div
            className="p-input-icon-left w-full search-box-input-container"
            style={{
              backgroundColor: 'var(--bq-surface-elevated)',
              borderRadius: '6px',
              border: '1px solid var(--bq-border-muted)',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            }}
          >
            <i
              className="pi pi-search"
              style={{ left: '0.75rem', color: 'var(--bq-text-tertiary)' }}
            />
            <InputText
              ref={searchInputRef}
              placeholder="Search for documents, funds, companies or widgets"
              className="p-inputtext-lg w-full"
              style={{
                width: '100%',
                border: 'none',
                paddingLeft: '2.5rem',
                backgroundColor: 'var(--bq-surface-elevated)',
                height: '44px',
                outline: 'none',
                color: search
                  ? 'var(--bq-text-primary)'
                  : 'var(--bq-text-secondary)',
              }}
              value={search}
              onKeyDown={(e) => {
                e.code === 'Enter' && onSearch();
              }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <Button
            onClick={onSearch}
            className="p-button"
            style={{
              height: '44px',
              minWidth: '80px',
              backgroundColor: 'var(--bq-color-info)',
              borderColor: 'var(--bq-color-info)',
              color: 'var(--bq-button-text)',
            }}
            disabled={!search.trim()}
          >
            Search
          </Button>
        </div>
        <Button
          icon="pi pi-times"
          className="p-button-rounded p-button-text"
          onClick={onClose}
          aria-label="Close"
          style={{ height: '44px' }}
        />
      </div>
    </div>
  );
};
